<template>
  <div class="theme-toggler">
    <!-- <img src="@/assets/images/icons/light-icon.svg" v-if="theme == 'light'" alt="#" class="sun" />
    <img src="@/assets/images/icons/dark-icon.svg" v-if="theme == 'dark'" alt="#" class="moon" /> -->
    <div :class="theme == 'light' ? 'togg light active' : 'togg light'" id="togg-light" @click="changeTheme('light')">
        <img src="@/assets/images/icons/v3-sun.svg" alt="#">
    </div>
    <div :class="theme == 'medium' ? 'togg medium active' : 'togg medium'" id="togg-medium" @click="changeTheme('medium')">
        <img src="@/assets/images/icons/v3-halfsun.svg" alt="#">
    </div>
    <div :class="theme == 'dark' ? 'togg dark active' : 'togg dark'" id="togg-dark" @click="changeTheme('dark')">
        <img src="@/assets/images/icons/v3-moon.svg" alt="#">
    </div>
  </div>
</template>

<script>
import store from "@/store";

export default {
  name: "ThemeTogglerV3",
  computed: {
      theme() {
          return store.getters.getCurrentTheme
      }
  },
  methods: {
    changeTheme: function ( themeSet ) {
    
      store.dispatch("setTheme", themeSet);

    },
  },
};
</script>

<style lang="scss" scoped>

// Arabic Css
body.theme-light.ar {
  .theme-toggler {
    width: 88px;
    height: 26px;
    background: #E7E7E7;
    border-radius: 16.5px;
    padding: 4px;
    position: relative;
    margin-left: 0px;
    // margin-right: 13px;
    margin-top: 20px;
    display: inline-flex;
    justify-content: space-between;

    .togg {
        width: 18px;
        height: 18px;
        border-radius: 18px;
        opacity: 0.15;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
    .togg.active {
        opacity: 1;
    }
    .togg.dark {
        background: #fff;
    }
    .togg.medium {
        background: #5C5C5C;

        img {
          margin-left: -2px;
        }
    }
    .togg.light {
        background: rgba(255, 168, 0, 1);
    }


    @keyframes move-right {
      from {
        left: 5px;
      }
      to {
        // transform: translateX(-1px);
        left: 35px
      }
    }
  }
}
body.theme-medium.ar {
  .theme-toggler {
    width: 88px;
    height: 26px;
    background: #E7E7E7;
    border-radius: 16.5px;
    padding: 4px;
    position: relative;
    margin-left: 0px;
    // margin-right: 13px;
    margin-top: 20px;
    display: inline-flex;
    justify-content: space-between;

    .togg {
        width: 18px;
        height: 18px;
        border-radius: 18px;
        opacity: 0.15;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
    .togg.active {
        opacity: 1;
    }
    .togg.dark {
        background: #fff;
    }
    .togg.medium {
        background: #5C5C5C;
        img {
          margin-left: -2px;
        }
    }
    .togg.light {
        background: rgba(255, 168, 0, 1);
    }


    @keyframes move-right {
      from {
        left: 5px;
      }
      to {
        // transform: translateX(-1px);
        left: 35px
      }
    }
  }
}
body.theme-dark.ar {
  .theme-toggler {
    width: 88px;
    height: 26px;
    background: #000000;
    border-radius: 16.5px;
    padding: 4px;
    position: relative;
    margin-left: 0px;
    // margin-right: 13px;
    margin-top: 20px;
    display: inline-flex;
    justify-content: space-between;

    .togg {
        width: 18px;
        height: 18px;
        border-radius: 18px;
        opacity: 0.15;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
    .togg.active {
        opacity: 1;
    }
    .togg.dark {
        background: #fff;
    }
    .togg.medium {
        background: #5C5C5C;
        img {
          margin-left: -2px;
        }
    }
    .togg.light {
        background: rgba(255, 168, 0, 1);
    }


    @keyframes move-right {
      from {
        left: 5px;
      }
      to {
        // transform: translateX(-1px);
        left: 35px
      }
    }
  }
}

// English Css
body.theme-light.en {
  .theme-toggler {
    width: 88px;
    height: 26px;
    background: #E7E7E7;
    border-radius: 16.5px;
    padding: 4px;
    position: relative;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 20px;
    display: inline-flex;
    justify-content: space-between;

    .togg {
        width: 18px;
        height: 18px;
        border-radius: 18px;
        opacity: 0.15;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
    .togg.active {
        opacity: 1;
    }
    .togg.dark {
        background: #fff;
    }
    .togg.medium {
        background: #5C5C5C;
    }
    .togg.light {
        background: rgba(255, 168, 0, 1);
    }


    @keyframes move-right {
      from {
        left: 5px;
      }
      to {
        // transform: translateX(-1px);
        left: 35px
      }
    }
  }
}
body.theme-medium.en {
  .theme-toggler {
    width: 88px;
    height: 26px;
    background: #E7E7E7;
    border-radius: 16.5px;
    padding: 4px;
    position: relative;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 20px;
    display: inline-flex;
    justify-content: space-between;

    .togg {
        width: 18px;
        height: 18px;
        border-radius: 18px;
        opacity: 0.15;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
    .togg.active {
        opacity: 1;
    }
    .togg.dark {
        background: #fff;
    }
    .togg.medium {
        background: #5C5C5C;
    }
    .togg.light {
        background: rgba(255, 168, 0, 1);
    }


    @keyframes move-right {
      from {
        left: 5px;
      }
      to {
        // transform: translateX(-1px);
        left: 35px
      }
    }
  }
}
body.theme-dark.en {
  .theme-toggler {
    width: 88px;
    height: 26px;
    background: #000000;
    border-radius: 16.5px;
    padding: 4px;
    position: relative;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 20px;
    display: inline-flex;
    justify-content: space-between;

    .togg {
        width: 18px;
        height: 18px;
        border-radius: 18px;
        opacity: 0.15;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
    .togg.active {
        opacity: 1;
    }
    .togg.dark {
        background: #fff;
    }
    .togg.medium {
        background: #5C5C5C;
    }
    .togg.light {
        background: rgba(255, 168, 0, 1);
    }


    @keyframes move-right {
      from {
        left: 5px;
      }
      to {
        // transform: translateX(-1px);
        left: 35px
      }
    }
  }
}


</style>